import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
} from '@/shared/components/ui/alert-dialog';
import {
  APP_ONLY_FEATURES,
  withTopicParticle,
} from '@/shared/constants/appOnlyFeatures';
import { useUIStore } from '@/stores/uiStore';

/**
 * M-03 X6 — 앱 전용 기능 공통 팝업. 앱 루트에 한 번만 둔다.
 * 버튼은 [확인] 하나. 설치 · 스토어 이동 안내는 두지 않는다 (M-13 문구 규칙).
 */
export const AppOnlyDialog = () => {
  const feature = useUIStore((s) => s.appOnlyFeature);
  const close = useUIStore((s) => s.closeAppOnly);
  const label = feature ? APP_ONLY_FEATURES[feature] : '';

  return (
    <AlertDialog open={feature !== null} onOpenChange={(o) => !o && close()}>
      <AlertDialogContent>
        <AlertDialogTitle>이 기능은 앱에서 이용해 주세요</AlertDialogTitle>
        <AlertDialogDescription>
          {withTopicParticle(label)} 앱에서 이용할 수 있어요.
        </AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogAction>확인</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
